import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getPaymentMethods } from "@services/paymentMethods.service";

export const fetchPayment = createAsyncThunk('/payment/fetchPayment', async () => {
  return await getPaymentMethods();
});

const initialState = {
  payment: {
    items: {},
    status: 'loading'
  },
  currentMethod: '',
}


export const donatSlice = createSlice({
  name: 'donat',
  initialState,
  reducers: {
    getFulldonat: (state, action) => {
      return action.payload;
    }
  },
  extraReducers: {
    [fetchPayment.pending]: (state) => {
      state.payment.items = { };
      state.payment.status = 'loading';
    },
    [fetchPayment.fulfilled]: (state, action) => {
      state.payment.items = action.payload;
      state.payment.status = 'loaded';
    },
    [fetchPayment.rejected]: (state) => {
      state.payment.items = {};
      state.payment.status = 'error';
    },
  }
})

export const { getFulldonat } = donatSlice.actions;

export default donatSlice.reducer;